import React from "react";
import { Modal, ModalDialog, Button } from "@mui/joy";
import styles from "./staffmanage.module.css";
import { mmdd } from "./rosterutils";

//전체학생정보 퇴원TODO — 겸직(활성 직무 2개 이상)이면 어느 파트를 퇴사 처리할지 버튼으로 고름 (타이핑 없음)
//onPick(positionId) = 그 파트로 퇴사직원 TODO 이동 / onPickAll() = 지금처럼 이름으로 이동(두 파트 다 보임)
const PartPickModal: React.FC<{
    open: boolean;
    userName: string;
    positions: { id: number; partName: string; branchLabel: string; startDate: string | null }[];
    onPick: (positionId: number) => void;
    onPickAll: () => void;
    onClose: () => void;
}> = (props) => {
    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog sx={{ width: "440px", maxWidth: "95vw" }}>
                <div className={styles.modalTitle}>{props.userName} · 퇴사할 파트 선택</div>
                <div className={styles.hint} style={{ marginBottom: "10px" }}>겸직 중입니다. 고른 파트만 퇴사 처리되고 다른 파트는 그대로 재직으로 남습니다.</div>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {props.positions.map((p) => (
                        <Button key={p.id} variant="outlined" color="neutral" size="lg" sx={{ justifyContent: "flex-start", fontFamily: "Apple_R", fontSize: "14px" }} onClick={() => props.onPick(p.id)}>
                            {p.branchLabel ? `${p.branchLabel} · ` : ""}{p.partName || "파트 없음"}{p.startDate ? <span style={{ marginLeft: "8px", fontSize: "12px", color: "#9ca3af" }}>입사 {mmdd(p.startDate)}</span> : null}
                        </Button>
                    ))}
                </div>
                <div className={styles.modalButtons}>
                    <div className={styles.hint}></div>
                    <div style={{ display: "flex", gap: "8px" }}>
                        <Button variant="plain" color="neutral" onClick={props.onClose}>닫기</Button>
                        <Button variant="soft" color="neutral" onClick={props.onPickAll}>{props.positions.length}개 파트 모두 보기</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default PartPickModal;
